import {
  getLeoUuid,
  LeoUUID,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class DeleteAPIKeyRPC implements
  LeoRPC<DeleteAPIKeyRPC.Request, DeleteAPIKeyRPC.Response, DeleteAPIKeyRPC.Errors.Errors>
{
  abstract execute(
    request: DeleteAPIKeyRPC.Request
  ): Promise<LeoRPCResult<DeleteAPIKeyRPC.Response, DeleteAPIKeyRPC.Errors.Errors>>;
}

export namespace DeleteAPIKeyRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    apiKeyId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isDeleteAPIKeyRPCRequest: boolean = true;
  
    readonly apiKeyId: LeoUUID;
  
  
    constructor(
    apiKeyId: LeoUUID
    ) {
      this.apiKeyId = apiKeyId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const apiKeyId = getLeoUuid(dto, "apiKeyId", InvalidRequestApiKeyIdError);
      return new Request(
        apiKeyId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          apiKeyId: this.apiKeyId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `DeleteAPIKeyRPC(apiKeyId='${this.apiKeyId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `DeleteAPIKeyRPC.Response()`;
  };

  export enum RPCError {
    InvalidApiKey = "INVALID_API_KEY"
  }

  export namespace Errors {
    
    export interface InvalidApiKeyDTO {
      code: string;
    }
    
    export class InvalidApiKey extends LeoRPCError<RPCError> {
      readonly isInvalidApiKey: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidApiKey;
        super(code);
      }
    
    
      toDTO(): InvalidApiKeyDTO {
        const dto: InvalidApiKeyDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidApiKey.prototype.toString = function toString(): string {
      return `DeleteAPIKeyRPC.INVALID_API_KEY()`;
    };
    

    export type Errors = InvalidApiKey;
    export type ErrorsDTO = InvalidApiKeyDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidApiKey:
          return new InvalidApiKey();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestApiKeyIdError extends DeleteAPIKeyRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestApiKeyIdError";
  }
}


export class InvalidResponseInvalidApiKeyError extends DeleteAPIKeyRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidApiKeyError";
  }
}

